// extracted by mini-css-extract-plugin
module.exports = {"actions":"BuyLoadSuccess_actions__TgSeM","back-link-button":"BuyLoadSuccess_back-link-button__T5RL6"};